import { useState, useEffect, useMemo } from 'react';
import * as Sentry from '@sentry/react';

import { useAppDispatch } from '../store/hooks';
import { setMobile, setTablet } from '../store/slices/appState';

const useMobileDetect = () => {
  const dispatch = useAppDispatch();
  const [width, setScreenSize] = useState(window.innerWidth);

  const isMobile = useMemo(() => width < 1100, [width]);
  const isTablet = useMemo(() => width > 600 && width < 1100, [width]);

  useEffect(() => {
    dispatch(setMobile(isMobile));
    dispatch(setTablet(isTablet));
    Sentry.setTag('application', isMobile ? 'mobile' : 'desktop');
  }, [dispatch, isMobile, isTablet]);

  useEffect(() => {
    const handleResize = () => {
      setScreenSize(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return isMobile;
};

export default useMobileDetect;
